export class clientRoutes {
  static agentRegister = "/";
  static createProperties = "/properties/create";
  static agentSignIn = "/agent/sign-in";
  static agentSignInVerifyEmail = "/agent/login/verify-email";
  static agencySignInVerifyEmail = "/agency/login/verify-email";

  static verifyLogin = "/login/verify";

  static agentProfileVerifyPhone = "/agent/create-profile/verify-phone";
  static agentProfileAgencyInfo = "/agent/create-profile/agency-info";
  static agentProfileCreateAgencyProfile = "/agent/create-agency-profile";
  static dashboardHome = "/properties";

  static home = "/";
  static testComponent = "/test-component";
  static dashboard = "/dashboard";
  static properties = "/properties";
  static workspace = "/workspace";
  static propertieView = "/properties/view/:id";
  static propertieEdit = "/properties/edit/:id";

  static PropertyPostList = "/workspace/property-post-list";
  static PropertyPostView =
    "/workspace/property-post-list/view/:propertyPostId";
  static AuctionList = "/workspace/auction-list";
  static AuctionView = "/workspace/auction/view/:scheduleId";
  static ReviewPostList = "/workspace/review-post-list";
  static ReviewPostView = "/workspace/review-post-list/view/:reviewPostId";
  static OnBoardingPostList = "/workspace/onboarding-post-list";
  static OnboardingPostView =
    "/workspace/onboarding-post/view/:onboardingPostId";

  static AnnouncementPostView =
    "/workspace/announcement-post/view/:announcementPostId";
  static AnnouncementPostList = "/workspace/announcement-post-list";
  static OpenHomeList = "/workspace/open-home-list";
  static AgencyScheduleOpenHomeView =
    "/workspace/agency-schedule-open-home/view/:scheduleId";
  static agentOpenHomeView = "/workspace/agent-open-home/view/:scheduleId";

  static agentProfileView = "/agent-profile";
  static agencyProfileView = "/agency-profile";

  static createPropertyBank = "/property-bank/create";
  static propertyBank = "/property-bank";
  static propertyBankView = "/property-bank/view/:id";

  static BrandList = "/brand-list";
  static createBrand = "/brand/create";
  static BrandView = "/brand/view/:id";

  static agents = "/agents";
  static agentView = "/agents/view/:id";
  static agentEdit = "/agents/edit/:id";

  static agencies = "/agencies";
  static agencyView = "/agencies/view/:id";
  static agencyAgentsDetails = "/agencies/view/:agencyId";
  static getAgencyAgentsDetails = (agencyId: string) =>
    `/agencies/view/${agencyId}`;
  static agencyEdit = "/agencies/edit/:id";
  static agencylogocolor = "/generate-agency-logo-colors";

  static users = "/users";
  static userCreate = "/users/create";
  static userView = "/users/view/:id";
  static userEdit = "/users/edit/:id";

  static profile = "/profile";
  static profileView = "/profile/view/:id";

  static referrals = "/referrals";
  static referralCreate = "/referrals/create";
  static referralView = "/referrals/view/:id";
  static referralEdit = "/referrals/edit/:id";

  static royaltyProgram = "/royalty-programs";
  static royaltyCreate = "/royalty-programs/create";
  static royaltyView = "/royalty-programs/view/:id";
  static royaltyEdit = "/royalty-programs/edit/:id";

  static propertyStages = "/property-stages";
  static propertyStageCreate = "/property-stages/create";
  static propertyStageView = "/property-stages/view/:id";
  static propertyStageEdit = "/property-stages/edit/:id";

  static designTemplates = "/design-templates";
  static designTemplateCreate = "/design-templates/create";
  static designTemplateView = "/design-templates/view/:id";
  static designTemplateEdit = "/design-templates/edit/:id";

  static subscriptions = "/subscriptions";
  static subscriptionCreate = "/subscriptions/create";
  static subscriptionView = "/subscriptions/view/:id";
  static subscriptionEdit = "/subscriptions/edit/:id";

  static designTemplateTypes = "/design-template-types";
  static designTemplateTypesCreate = "/design-template-types/create";
  static designTemplateTypesView = "/design-template-types/view/:id";
  static designTemplateTypesEdit = "/design-template-types/edit/:id";

  static manualWalletPoints = "/manual-wallet-points";
  static manualWalletPointsCreate = "/manual-wallet-points/create";
  static manualWalletPointsView = "/manual-wallet-points/view/:id";
  static manualWalletPointsEdit = "/manual-wallet-points/edit/:id";

  static manageInvites = "/manage-invites";

  static manageInvitesDetails = "/manage-invites/details/:id";

  // static designTemplates = "/design-templates";

  static register = "/register";
  static login = "/login";

  static resetPassword = "/login/reset-password";

  static createPassword = "/create-password";

  static resetPasswordVerify = "/login/reset-password/verify";

  static agentVerifyEmail = "/register/agent/verify-email";
  static agentProfile = "/agent/create-profile/agent-info";
  static agentVerifyPhone = "/agent/create-profile/verify-phone";

  static agencyVerifyEmail = "/register/agency/verify-email";
  static agencyProfileAgencyInfo = "/agency/create-profile/agency-info";
  static agencyProfileVerifyPhone = "/agency/create-profile/verify-phone";
  static agencyProfileAgentInfo = "/agency/create-profile/agent-info";
  static agencyVerifyPhone = "/agency/verify-phone";
}
